import { render } from "./MFlag.vue?vue&type=template&id=619135a4"
import script from "./MFlag.vue?vue&type=script&lang=js"
export * from "./MFlag.vue?vue&type=script&lang=js"

import "./MFlag.vue?vue&type=style&index=0&id=619135a4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__